import React from "react";
import { Button, Table } from "react-bootstrap";

export default function CertStatusCard({
  activeKey,
  selectedDays,
  selectedLocation,
  unslotedMembers,
  dataDirty,
  slots,
  onSelectNewDay,
  onRefreshStatus,
  onChangeRoadTestCertificateStatus,
  statusAlerts,
  noDateSelectedPrompt,
  noSlottedStudentsPrompt,
}) {
  function renderCertStatusTable(students, usesStudentSlots) {
    return (
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>School</th>
            <th>Certificate Paid</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {students.map((x, index) => {
            return (
              <tr key={x.timestamp}>
                <td>{x.fName + " " + x.lName}</td>
                <td>{x.drivingSchool}</td>
                {!x.hasOwnProperty("certPaymentStatus") ||
                x.certPaymentStatus === false ? (
                  x.drivingSchool.includes("Parkway Driving School") ? (
                    <td>Not Paid</td>
                  ) : (
                    <td>N/A</td>
                  )
                ) : (
                  <td>Paid</td>
                )}
                <td>
                  <Button
                    disabled={x.certPaymentStatus === true}
                    onClick={() =>
                      onChangeRoadTestCertificateStatus(
                        index,
                        "certPaid",
                        usesStudentSlots,
                      )
                    }
                    size="sm"
                  >
                    Mark Paid
                  </Button>
                  <Button
                    disabled={
                      !x.hasOwnProperty("certPaymentStatus") ||
                      x.certPaymentStatus === false
                    }
                    onClick={() =>
                      onChangeRoadTestCertificateStatus(
                        index,
                        "certNotPaid",
                        usesStudentSlots,
                      )
                    }
                    size="sm"
                  >
                    Mark Not Paid
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  return (
    <div>
      {activeKey === "viewCertStatus" ? (
        <div>{statusAlerts}</div>
      ) : null}

      {selectedDays.length > 0 ? (
        <div>
          {selectedLocation.includes("RMV Site") ||
          selectedLocation.includes("Braintree - Granite St") ? (
            <div>
              {unslotedMembers.length === 0 ? (
                <div>
                  <div>
                    No students found. Please select a new day or add some
                    students.
                  </div>
                  <br></br>
                  <Button
                    variant="primary"
                    onClick={onSelectNewDay}
                  >
                    Select New Day Range
                  </Button>
                  <br></br>
                </div>
              ) : (
                <div>
                  <Button
                    className="rightBut"
                    disabled={dataDirty}
                    onClick={onRefreshStatus}
                  >
                    {" "}
                    Refresh Status{" "}
                  </Button>
                  <br></br>
                  <br></br>
                  {!dataDirty
                    ? renderCertStatusTable(
                        unslotedMembers,
                        false,
                      )
                    : null}
                </div>
              )}
            </div>
          ) : (
            <div>
              {slots.length === 0 ? (
                noSlottedStudentsPrompt
              ) : (
                <div>
                  <Button
                    className="rightBut"
                    disabled={dataDirty}
                    onClick={onRefreshStatus}
                  >
                    {" "}
                    Refresh Status{" "}
                  </Button>
                  <br></br>
                  <br></br>
                  {!dataDirty
                    ? renderCertStatusTable(
                        slots
                          .filter(
                            (x) =>
                              Object.keys(x.value).length > 0 &&
                              x.value.constructor === Object,
                          )
                          .map((x) => x.value),
                        true,
                      )
                    : null}
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        noDateSelectedPrompt
      )}
    </div>
  );
}
